/* Newsletter validation is handled by window.egNewsletterTrySubmit in theme.liquid */

(function () {
  var MQ = window.matchMedia('(min-width: 769px)');

  function activeSlide(photos) {
    var main = photos.querySelector('.product__main-photos');
    if (!main) return null;
    return (
      main.querySelector('.product-main-slide.is-selected') ||
      main.querySelector('.product-main-slide.starting-slide') ||
      main.querySelector('.product-main-slide')
    );
  }

  function mediaHeight(photos) {
    var slide = activeSlide(photos);
    if (!slide) {
      var main = photos.querySelector('.product__main-photos');
      return main ? Math.round(main.getBoundingClientRect().height || 0) : 0;
    }
    var wrap = slide.querySelector('.image-wrap') || slide;
    return Math.round(wrap.getBoundingClientRect().height || slide.offsetHeight || 0);
  }

  function lockThumbsHeight(photos) {
    if (!MQ.matches || !photos || photos.dataset.egThumbsHeightLocked === 'true') return;

    var thumbs = photos.querySelector('.product__thumbs--beside');
    if (!thumbs) return;

    var slide = activeSlide(photos);
    var img = slide && slide.querySelector('img');
    if (img && !img.complete) {
      img.addEventListener(
        'load',
        function () {
          lockThumbsHeight(photos);
        },
        { once: true }
      );
      return;
    }

    var height = mediaHeight(photos);
    if (height < 1) return;

    thumbs.style.height = height + 'px';
    thumbs.style.minHeight = height + 'px';
    photos.dataset.egThumbsHeightLocked = 'true';
  }

  function lockAll(root) {
    (root || document).querySelectorAll('.product__photos--beside').forEach(lockThumbsHeight);
  }

  function unlock(root) {
    (root || document)
      .querySelectorAll('.product__photos--beside[data-eg-thumbs-height-locked]')
      .forEach(function (photos) {
        delete photos.dataset.egThumbsHeightLocked;
        var thumbs = photos.querySelector('.product__thumbs--beside');
        if (thumbs) {
          thumbs.style.height = '';
          thumbs.style.minHeight = '';
        }
      });
  }

  function scheduleLock(root) {
    requestAnimationFrame(function () {
      lockAll(root);
      setTimeout(function () {
        lockAll(root);
      }, 100);
      setTimeout(function () {
        lockAll(root);
      }, 400);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      scheduleLock(document);
    });
  } else {
    scheduleLock(document);
  }

  document.addEventListener('modalOpen', function () {
    var modal = document.querySelector('.modal--quick-shop.modal--is-active');
    if (modal) unlock(modal);
    scheduleLock(modal || document);
  });

  document.addEventListener('quickview:loaded', function () {
    scheduleLock(document);
  });

  MQ.addEventListener('change', function () {
    unlock(document);
    if (MQ.matches) scheduleLock(document);
  });

  window.addEventListener('load', function () {
    scheduleLock(document);
  });
})();

(function () {
  var APPSTLE_HIDE_SELECTORS = [
    '.appstle_subscription_wrapper',
    '.appstle_subscription_widget',
    '.appstle_sub_widget',
    '[id^="appstle_subscription_widget"]',
    '.appstle_oneTime',
    '.appstle_oneTime_container',
    '.appstle_one_time_details',
    '.appstle_selectWidget_wrapper'
  ].join(',');
  var adding = false;

  function closestSection(el) {
    return el && el.closest ? el.closest('.product-section') : null;
  }

  function parsePlanMap(form) {
    var mapEl = form.querySelector('[data-subscription-plan-map]');
    if (!mapEl) return {};
    try {
      return JSON.parse(mapEl.textContent);
    } catch (err) {
      return {};
    }
  }

  function formatMoney(cents) {
    if (window.theme && theme.Currency && theme.settings) {
      return theme.Currency.formatMoney(cents, theme.settings.moneyFormat);
    }
    return cents;
  }

  function applySubscriptionPrice(section, plan) {
    if (!section || !plan) return;

    var priceEl = section.querySelector('[data-product-price]');
    var compareEl = section.querySelector('[data-compare-price]');
    var wrapEl = section.querySelector('[data-product-price-wrap]');
    var saveEl = section.querySelector('[data-save-price]');
    var compareA11y = section.querySelector('[data-compare-price-a11y]');
    var priceA11y = section.querySelector('[data-a11y-price]');
    var onSale = Number(plan.compare_at_price) > Number(plan.price);

    if (priceEl) {
      priceEl.innerHTML = formatMoney(plan.price);
      priceEl.classList.toggle('on-sale', onSale);
    }

    if (compareEl) {
      compareEl.innerHTML = onSale ? formatMoney(plan.compare_at_price) : '';
    }

    if (wrapEl) {
      wrapEl.classList.toggle('hide', !onSale);
    }

    if (priceA11y) {
      priceA11y.setAttribute('aria-hidden', onSale ? 'false' : 'true');
    }

    if (compareA11y) {
      compareA11y.setAttribute('aria-hidden', onSale ? 'false' : 'true');
    }

    if (saveEl) {
      if (onSale && window.theme && theme.strings && theme.strings.savePrice) {
        var savings = Number(plan.compare_at_price) - Number(plan.price);
        if (theme.settings && theme.settings.saveType === 'percent') {
          savings = Math.round((savings * 100) / Number(plan.compare_at_price)) + '%';
        } else {
          savings = formatMoney(savings);
        }
        saveEl.classList.remove('hide');
        saveEl.innerHTML = theme.strings.savePrice.replace('[saved_amount]', savings);
      } else {
        saveEl.classList.add('hide');
      }
    }
  }

  function hideAppstleWidgets(root) {
    (root || document).querySelectorAll(APPSTLE_HIDE_SELECTORS).forEach(function (el) {
      if (
        !el.closest('.product-section--subscription') &&
        !el.closest('.product-single__form--subscription') &&
        !document.body.classList.contains('template-product-subscription')
      ) {
        return;
      }
      el.style.setProperty('display', 'none', 'important');
    });
  }

  function currentPlan(form) {
    var variantSelect = form.querySelector('[data-product-select]');
    var variantId = variantSelect && variantSelect.value;
    var plans = parsePlanMap(form)[String(variantId)] || [];
    var input = form.querySelector('[data-subscription-selling-plan]');
    var currentId = input && input.value;
    return (
      plans.find(function (item) {
        return String(item.id) === String(currentId);
      }) || plans[0]
    );
  }

  function syncPlanFields(form, plan) {
    if (!form || !plan) return;

    var input = form.querySelector('[data-subscription-selling-plan]');
    if (input) {
      input.value = plan.id;
      input.setAttribute('value', plan.id);
    }

    var nameEl = form.querySelector('[data-subscription-plan-name]');
    if (nameEl && plan.name) {
      nameEl.textContent = plan.name;
    }

    form.querySelectorAll('[name="selling_plan"]').forEach(function (el) {
      if (el === input) return;
      el.removeAttribute('name');
      if (el.type === 'radio' || el.type === 'checkbox') {
        el.checked = String(el.value) === String(plan.id);
      }
    });

    if (input && input.parentNode) {
      form.appendChild(input);
    }

    applySubscriptionPrice(closestSection(form) || document, plan);
  }

  function forceSubscription(form, variantId) {
    var plans = parsePlanMap(form)[String(variantId)] || [];
    var picker = form.querySelector('[data-subscription-plan-picker]');
    var input = form.querySelector('[data-subscription-selling-plan]');
    var currentId = (picker && picker.value) || (input && input.value);
    var plan =
      plans.find(function (item) {
        return String(item.id) === String(currentId);
      }) || plans[0];

    if (picker && plans.length) {
      picker.innerHTML = '';
      plans.forEach(function (item, index) {
        var option = document.createElement('option');
        option.value = item.id;
        option.textContent = item.name || '';
        option.selected = plan ? String(item.id) === String(plan.id) : index === 0;
        picker.appendChild(option);
      });
    }

    syncPlanFields(form, plan);
    hideAppstleWidgets(closestSection(form) || form);
  }

  function quantityFor(form) {
    var input =
      form.querySelector('[name="quantity"]') ||
      document.querySelector('input[name="quantity"][form="' + form.id + '"]');
    var qty = input ? parseInt(input.value, 10) : 1;
    return qty > 0 ? qty : 1;
  }

  function variantIdFor(form) {
    var select = form.querySelector('[data-product-select]');
    return select && select.value;
  }

  function isCartAdd(url) {
    var value = '';
    if (typeof url === 'string') value = url;
    else if (url && typeof url.url === 'string') value = url.url;
    return value.indexOf('/cart/add') !== -1;
  }

  function isSubscriptionGiftForm(form) {
    return !!(
      form &&
      form.classList &&
      form.classList.contains('product-single__form--subscription') &&
      form.querySelector('[data-subscription-gift]')
    );
  }

  function giftEnabled(form) {
    if (!isSubscriptionGiftForm(form)) return false;
    var toggle = form.querySelector('[data-subscription-gift-toggle]');
    return !!(toggle && toggle.checked);
  }

  function parseProvinces(countrySelect) {
    if (!countrySelect || countrySelect.selectedIndex < 0) return [];
    var option = countrySelect.options[countrySelect.selectedIndex];
    try {
      return JSON.parse((option && option.getAttribute('data-provinces')) || '[]');
    } catch (err) {
      return [];
    }
  }

  function populateGiftProvinces(form) {
    if (!isSubscriptionGiftForm(form)) return;
    var wrap = form.querySelector('[data-subscription-gift]');
    var countrySelect = wrap.querySelector('[data-subscription-gift-country]');
    var provinceSelect = wrap.querySelector('[data-subscription-gift-province]');
    var provinceWrap = wrap.querySelector('[data-subscription-gift-province-container]');
    if (!countrySelect || !provinceSelect) return;

    var provinces = parseProvinces(countrySelect);
    var current = provinceSelect.value;
    var enabled = giftEnabled(form);
    provinceSelect.innerHTML = '';

    if (!provinces.length) {
      if (provinceWrap) provinceWrap.hidden = true;
      provinceSelect.required = false;
      provinceSelect.disabled = true;
      return;
    }

    if (provinceWrap) provinceWrap.hidden = false;
    provinces.forEach(function (pair) {
      var option = document.createElement('option');
      option.value = pair[0];
      option.textContent = pair[1] || pair[0];
      if (String(pair[0]) === String(current) || String(pair[1]) === String(current)) {
        option.selected = true;
      }
      provinceSelect.appendChild(option);
    });
    provinceSelect.disabled = !enabled;
    provinceSelect.required = enabled;
  }

  function syncGiftFields(form) {
    if (!isSubscriptionGiftForm(form)) return;
    var wrap = form.querySelector('[data-subscription-gift]');
    if (!wrap) return;

    var toggle = wrap.querySelector('[data-subscription-gift-toggle]');
    var fields = wrap.querySelector('[data-subscription-gift-fields]');
    var countrySelect = wrap.querySelector('[data-subscription-gift-country]');
    var enabled = giftEnabled(form);

    if (fields) fields.hidden = !enabled;
    if (toggle) toggle.setAttribute('aria-expanded', enabled ? 'true' : 'false');

    if (countrySelect) {
      countrySelect.value = 'Canada';
    }

    wrap.querySelectorAll('[data-subscription-gift-property]').forEach(function (el) {
      var optional = el.getAttribute('data-gift-optional') === 'true';
      el.disabled = !enabled;
      el.required = enabled && !optional;
    });

    populateGiftProvinces(form);
  }

  function giftPropertiesFromForm(form) {
    var props = {};
    if (!isSubscriptionGiftForm(form) || !giftEnabled(form)) return props;
    form.querySelectorAll('[data-subscription-gift] [data-subscription-gift-property]').forEach(function (el) {
      if (el.disabled) return;
      var key = el.getAttribute('data-subscription-gift-property');
      var value = String(el.value || '').replace(/^\s+|\s+$/g, '');
      if (key && value) props[key] = value;
    });
    return props;
  }

  function giftFieldsValid(form) {
    if (!isSubscriptionGiftForm(form)) return true;
    syncGiftFields(form);
    if (!giftEnabled(form)) return true;
    var fields = form.querySelectorAll('[data-subscription-gift] [data-subscription-gift-property]');
    for (var i = 0; i < fields.length; i++) {
      var el = fields[i];
      if (el.disabled) continue;
      el.value = String(el.value || '').replace(/^\s+|\s+$/g, '');
    }
    if (typeof form.reportValidity === 'function') {
      return form.reportValidity();
    }
    for (var j = 0; j < fields.length; j++) {
      if (!fields[j].disabled && fields[j].required && !fields[j].value) {
        if (typeof fields[j].focus === 'function') fields[j].focus();
        return false;
      }
    }
    return true;
  }

  function applyPlanToJson(data, plan) {
    if (!data || !plan) return data;
    var props = giftPropertiesFromForm(subscriptionFormForRequest());
    function attach(item) {
      item.selling_plan = Number(plan.id);
      if (Object.keys(props).length) {
        item.properties = Object.assign({}, item.properties || {}, props);
      }
    }
    if (Array.isArray(data.items)) {
      data.items.forEach(attach);
    } else {
      attach(data);
    }
    return data;
  }

  function countryFor(form) {
    var section = closestSection(form);
    var country =
      (section && section.getAttribute('data-country')) ||
      (window.Shopify && Shopify.country) ||
      '';
    return country ? String(country).toUpperCase() : '';
  }

  function cartAddUrl(form) {
    var url = theme.routes.cartAdd;
    var country = countryFor(form);
    if (!country || url.indexOf('country=') !== -1) return url;
    return url + (url.indexOf('?') === -1 ? '?' : '&') + 'country=' + encodeURIComponent(country);
  }

  function applyPlanToFormData(formData, plan, variantId, form) {
    if (!formData || !plan || typeof formData.delete !== 'function') return formData;
    formData.delete('selling_plan');
    formData.append('selling_plan', String(plan.id));
    if (variantId) {
      formData.delete('id');
      formData.append('id', String(variantId));
    }
    var sourceForm = form || subscriptionFormForRequest();
    var giftKeys = [
      'First Name',
      'Last Name',
      'Street Address',
      'Apartment',
      'City',
      'Province',
      'Postal Code',
      'Country',
      'Gift Recipient Name',
      'Gift Recipient Address'
    ];
    if (sourceForm) {
      sourceForm.querySelectorAll('[data-subscription-gift-property]').forEach(function (el) {
        var key = el.getAttribute('data-subscription-gift-property');
        if (key && giftKeys.indexOf(key) === -1) giftKeys.push(key);
      });
    }
    giftKeys.forEach(function (key) {
      formData.delete('properties[' + key + ']');
    });
    var giftProps = giftPropertiesFromForm(sourceForm);
    Object.keys(giftProps).forEach(function (key) {
      formData.append('properties[' + key + ']', giftProps[key]);
    });
    return formData;
  }

  function subscriptionFormForRequest() {
    return document.querySelector('.product-single__form--subscription');
  }

  function patchCartAddBody(input, init, plan) {
    if (!plan) return init;
    init = init ? Object.assign({}, init) : {};
    var body = init.body;

    if (body instanceof FormData) {
      applyPlanToFormData(body, plan, variantIdFor(subscriptionFormForRequest()), subscriptionFormForRequest());
      return init;
    }

    if (typeof body === 'string') {
      try {
        init.body = JSON.stringify(applyPlanToJson(JSON.parse(body), plan));
        return init;
      } catch (err) {
        var params = new URLSearchParams(body);
        params.set('selling_plan', String(plan.id));
        var giftProps = giftPropertiesFromForm(subscriptionFormForRequest());
        Object.keys(giftProps).forEach(function (key) {
          params.set('properties[' + key + ']', giftProps[key]);
        });
        init.body = params.toString();
        return init;
      }
    }

    if (input && typeof input === 'object' && typeof input.url === 'string' && !init.body) {
      return init;
    }

    return init;
  }

  function hookFetch() {
    if (window.fetch && window.fetch.__nsSubscriptionPatched) return;

    var originalFetch = window.fetch.bind(window);

    function patchedFetch(input, init) {
      var form = subscriptionFormForRequest();
      if (form && isCartAdd(input) && (!init || init.method === undefined || String(init.method).toUpperCase() === 'POST')) {
        init = patchCartAddBody(input, init, currentPlan(form));
        var localized = cartAddUrl(form);
        if (typeof input === 'string') {
          input = localized;
        } else if (input && typeof input.url === 'string') {
          input = new Request(localized, input);
        }
      }
      return originalFetch(input, init);
    }

    patchedFetch.__nsSubscriptionPatched = true;

    try {
      Object.defineProperty(window, 'fetch', {
        configurable: true,
        writable: true,
        value: patchedFetch
      });
    } catch (err) {
      window.fetch = patchedFetch;
    }
  }

  function addSubscriptionItem(form) {
    if (adding) return;
    var btn = form.querySelector('[data-add-to-cart]');
    if (btn && btn.disabled) return;

    var plan = currentPlan(form);
    var variantId = variantIdFor(form);
    if (!plan || !plan.id || !variantId) return;

    adding = true;
    if (btn) btn.classList.add('btn--loading');

    var formData = new FormData(form);
    applyPlanToFormData(formData, plan, variantId, form);

    fetch(cartAddUrl(form), {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: formData
    })
      .then(function (response) {
        return response.json().then(function (data) {
          return { ok: response.ok, data: data };
        });
      })
      .then(function (result) {
        adding = false;
        if (btn) btn.classList.remove('btn--loading');

        if (!result.ok || result.data.status === 422) {
          var error = result.data || {};
          var errors = form.querySelector('.errors');
          if (errors) errors.remove();
          var errorDiv = document.createElement('div');
          errorDiv.className = 'errors text-center';
          errorDiv.textContent = error.description || error.message || 'Unable to add subscription to cart';
          form.appendChild(errorDiv);
          form.dispatchEvent(
            new CustomEvent('ajaxProduct:error', {
              detail: { errorMessage: error.description || error.message },
              bubbles: true
            })
          );
          return;
        }

        var product = result.data.items ? result.data.items[0] : result.data;
        if (theme.settings && theme.settings.cartType === 'page') {
          window.location = theme.routes.cartPage;
          return;
        }

        form.dispatchEvent(
          new CustomEvent('ajaxProduct:added', {
            detail: { product: product, addToCartBtn: btn },
            bubbles: true
          })
        );
        document.dispatchEvent(new CustomEvent('ajaxProduct:added', { detail: { product: product, addToCartBtn: btn } }));
      })
      .catch(function () {
        adding = false;
        if (btn) btn.classList.remove('btn--loading');
      });
  }

  function bindForm(form) {
    if (!form || form.getAttribute('data-subscription-bound') === '1') return;
    form.setAttribute('data-subscription-bound', '1');

    forceSubscription(form, variantIdFor(form));
    hookFetch();

    form.addEventListener(
      'submit',
      function (evt) {
        evt.preventDefault();
        evt.stopImmediatePropagation();
        if (!giftFieldsValid(form)) return;
        forceSubscription(form, variantIdFor(form));
        addSubscriptionItem(form);
      },
      true
    );

    form.addEventListener(
      'click',
      function (evt) {
        var btn = evt.target.closest('[data-add-to-cart], button[name="add"]');
        if (!btn || !form.contains(btn)) return;
        evt.preventDefault();
        evt.stopImmediatePropagation();
        if (!giftFieldsValid(form)) return;
        forceSubscription(form, variantIdFor(form));
        addSubscriptionItem(form);
      },
      true
    );

    var picker = form.querySelector('[data-subscription-plan-picker]');
    if (picker) {
      picker.addEventListener('change', function () {
        var input = form.querySelector('[data-subscription-selling-plan]');
        if (input) input.value = picker.value;
        forceSubscription(form, variantIdFor(form));
      });
    }

    syncGiftFields(form);
    var giftToggle = form.querySelector('[data-subscription-gift-toggle]');
    if (giftToggle) {
      giftToggle.addEventListener('change', function () {
        syncGiftFields(form);
      });
    }
    var giftCountry = form.querySelector('[data-subscription-gift-country]');
    if (giftCountry) {
      giftCountry.addEventListener('change', function () {
        populateGiftProvinces(form);
      });
    }
  }

  function initSubscriptionForms(root) {
    (root || document).querySelectorAll('.product-single__form--subscription').forEach(bindForm);
    hideAppstleWidgets(root || document);
  }

  document.addEventListener('variant:change', function (event) {
    var variant = event.detail && event.detail.variant;
    if (!variant) return;
    var section = closestSection(event.target) || document.querySelector('.product-section--subscription');
    if (!section || !section.hasAttribute('data-subscription-only')) return;
    var form = section.querySelector('.product-single__form--subscription');
    if (form) forceSubscription(form, variant.id);
  });

  [
    'AppstleSubscription:SubscriptionWidget:widgetInitialised',
    'AppstleSubscription:SubscriptionWidget:SellingPlanDeSelected',
    'AppstleSubscription:SubscriptionWidget:sellingPlanChanged',
    'appstle:subscription-widget:loaded'
  ].forEach(function (eventName) {
    document.addEventListener(eventName, function () {
      initSubscriptionForms(document);
      document.querySelectorAll('.product-single__form--subscription').forEach(function (form) {
        forceSubscription(form, variantIdFor(form));
      });
    });
  });

  var observer = new MutationObserver(function (mutations) {
    var shouldSync = mutations.some(function (mutation) {
      return Array.prototype.some.call(mutation.addedNodes, function (node) {
        if (node.nodeType !== 1) return false;
        return (
          (node.matches && node.matches(APPSTLE_HIDE_SELECTORS)) ||
          (node.querySelector && node.querySelector(APPSTLE_HIDE_SELECTORS)) ||
          (node.matches && node.matches('.product-single__form--subscription'))
        );
      });
    });
    if (shouldSync) initSubscriptionForms(document);
  });

  if (document.body) {
    observer.observe(document.body, { childList: true, subtree: true });
  }

  hookFetch();
  initSubscriptionForms(document);
})();

(function () {
  var APPSTLE_HIDE_SELECTORS = [
    '.appstle_subscription_wrapper',
    '.appstle_subscription_widget',
    '.appstle_sub_widget',
    '[id^="appstle_subscription_widget"]',
    '.appstle_oneTime',
    '.appstle_oneTime_container',
    '.appstle_one_time_details',
    '.appstle_selectWidget_wrapper'
  ].join(',');

  function closestSection(el) {
    return el && el.closest ? el.closest('.product-section') : null;
  }

  function parsePlanMap(form) {
    var mapEl = form.querySelector('[data-subscription-plan-map]');
    if (!mapEl) return {};
    try {
      return JSON.parse(mapEl.textContent);
    } catch (err) {
      return {};
    }
  }

  function formatMoney(cents) {
    if (window.theme && theme.Currency && theme.settings) {
      return theme.Currency.formatMoney(cents, theme.settings.moneyFormat);
    }
    return cents;
  }

  function applySubscriptionPrice(section, plan) {
    if (!section || !plan) return;

    var priceEl = section.querySelector('[data-product-price]');
    var compareEl = section.querySelector('[data-compare-price]');
    var wrapEl = section.querySelector('[data-product-price-wrap]');
    var saveEl = section.querySelector('[data-save-price]');
    var compareA11y = section.querySelector('[data-compare-price-a11y]');
    var priceA11y = section.querySelector('[data-a11y-price]');
    var onSale = Number(plan.compare_at_price) > Number(plan.price);

    if (priceEl) {
      priceEl.innerHTML = formatMoney(plan.price);
      priceEl.classList.toggle('on-sale', onSale);
    }

    if (compareEl) {
      compareEl.innerHTML = onSale ? formatMoney(plan.compare_at_price) : '';
    }

    if (wrapEl) {
      wrapEl.classList.toggle('hide', !onSale);
    }

    if (priceA11y) {
      priceA11y.setAttribute('aria-hidden', onSale ? 'false' : 'true');
    }

    if (compareA11y) {
      compareA11y.setAttribute('aria-hidden', onSale ? 'false' : 'true');
    }

    if (saveEl) {
      if (onSale && window.theme && theme.strings && theme.strings.savePrice) {
        var savings = Number(plan.compare_at_price) - Number(plan.price);
        if (theme.settings && theme.settings.saveType === 'percent') {
          savings = Math.round((savings * 100) / Number(plan.compare_at_price)) + '%';
        } else {
          savings = formatMoney(savings);
        }
        saveEl.classList.remove('hide');
        saveEl.innerHTML = theme.strings.savePrice.replace('[saved_amount]', savings);
      } else {
        saveEl.classList.add('hide');
      }
    }
  }

  function hideAppstleWidgets(root) {
    (root || document).querySelectorAll(APPSTLE_HIDE_SELECTORS).forEach(function (el) {
      if (!el.closest('.product-section--subscription') && !el.closest('.product-single__form--subscription') && !document.body.classList.contains('template-product-subscription')) {
        return;
      }
      el.style.setProperty('display', 'none', 'important');
      el.setAttribute('hidden', 'hidden');
      el.setAttribute('aria-hidden', 'true');
    });
  }

  function stripDuplicateSellingPlanInputs(form) {
    var canonical = form.querySelector('[data-subscription-selling-plan]');
    form.querySelectorAll('[name="selling_plan"]').forEach(function (el) {
      if (el !== canonical) {
        el.removeAttribute('name');
        if (el.type === 'radio' || el.type === 'checkbox') {
          el.checked = false;
        }
      }
    });
  }

  function syncAppstleToPlan(form, planId) {
    if (!planId) return;

    form.querySelectorAll('input[name="selling_plan"], input[name="sellingPlan"], select[name="selling_plan"]').forEach(function (el) {
      if (el.hasAttribute('data-subscription-selling-plan')) return;
      if (el.type === 'radio' || el.type === 'checkbox') {
        el.checked = String(el.value) === String(planId);
        if (el.checked) {
          el.dispatchEvent(new Event('change', { bubbles: true }));
        }
      } else if (el.tagName === 'SELECT') {
        el.value = planId;
      } else {
        el.value = planId;
      }
    });
  }

  function setSellingPlan(form, plan) {
    var select = form.querySelector('[data-subscription-selling-plan]');
    if (!select || !plan) return;

    select.value = plan.id;
    if (select.value !== String(plan.id)) {
      var option = document.createElement('option');
      option.value = plan.id;
      option.textContent = plan.name || '';
      option.setAttribute('data-price', plan.price);
      option.setAttribute('data-compare-at-price', plan.compare_at_price);
      option.selected = true;
      select.appendChild(option);
    }

    var nameEl = form.querySelector('[data-subscription-plan-name]');
    if (nameEl && plan.name) {
      nameEl.textContent = plan.name;
    }

    stripDuplicateSellingPlanInputs(form);
    syncAppstleToPlan(form, plan.id);
    applySubscriptionPrice(closestSection(form) || document, plan);
  }

  function plansForVariant(form, variantId) {
    var map = parsePlanMap(form);
    return map[String(variantId)] || [];
  }

  function rebuildPlanSelect(form, plans) {
    var select = form.querySelector('[data-subscription-selling-plan]');
    var wrap = form.querySelector('[data-subscription-plans]');
    if (!select) return;

    select.innerHTML = '';
    plans.forEach(function (plan, index) {
      var option = document.createElement('option');
      option.value = plan.id;
      option.textContent = plan.name || '';
      option.setAttribute('data-price', plan.price);
      option.setAttribute('data-compare-at-price', plan.compare_at_price);
      if (index === 0) option.selected = true;
      select.appendChild(option);
    });

    if (wrap) {
      wrap.classList.toggle('product-subscription-plans--single', plans.length < 2);
    }
  }

  function forceSubscription(form, variantId) {
    var plans = plansForVariant(form, variantId);
    var select = form.querySelector('[data-subscription-selling-plan]');
    var currentId = select && select.value;
    var plan = plans.find(function (item) {
      return String(item.id) === String(currentId);
    }) || plans[0];

    if (!plan && select && select.value) {
      var selected = select.options[select.selectedIndex];
      plan = {
        id: select.value,
        name: selected ? selected.textContent : '',
        price: selected ? selected.getAttribute('data-price') : '',
        compare_at_price: selected ? selected.getAttribute('data-compare-at-price') : ''
      };
    }

    if (plans.length) {
      rebuildPlanSelect(form, plans);
    }

    setSellingPlan(form, plan || plans[0]);
    hideAppstleWidgets(closestSection(form) || form);
  }

  function bindForm(form) {
    if (!form || form.getAttribute('data-subscription-bound') === '1') return;
    form.setAttribute('data-subscription-bound', '1');

    var variantSelect = form.querySelector('[data-product-select]');
    forceSubscription(form, variantSelect && variantSelect.value);

    form.addEventListener(
      'submit',
      function () {
        var variantId = variantSelect && variantSelect.value;
        forceSubscription(form, variantId);
      },
      true
    );

    var planSelect = form.querySelector('[data-subscription-selling-plan]');
    if (planSelect) {
      planSelect.addEventListener('change', function () {
        var plans = plansForVariant(form, variantSelect && variantSelect.value);
        var plan = plans.find(function (item) {
          return String(item.id) === String(planSelect.value);
        }) || plans[0];
        setSellingPlan(form, plan);
      });
    }
  }

  function initSubscriptionForms(root) {
    (root || document).querySelectorAll('.product-single__form--subscription').forEach(bindForm);
    hideAppstleWidgets(root || document);
  }

  document.addEventListener('variant:change', function (event) {
    var variant = event.detail && event.detail.variant;
    if (!variant) return;

    var target = event.target;
    var section = closestSection(target) || document.querySelector('.product-section--subscription');
    if (!section || !section.hasAttribute('data-subscription-only')) return;

    var form = section.querySelector('.product-single__form--subscription');
    if (!form) return;

    forceSubscription(form, variant.id);
  });

  [
    'AppstleSubscription:SubscriptionWidget:widgetInitialised',
    'AppstleSubscription:SubscriptionWidget:SellingPlanDeSelected',
    'AppstleSubscription:SubscriptionWidget:sellingPlanChanged',
    'appstle:subscription-widget:loaded'
  ].forEach(function (eventName) {
    document.addEventListener(eventName, function () {
      initSubscriptionForms(document);
      document.querySelectorAll('.product-single__form--subscription').forEach(function (form) {
        var variantSelect = form.querySelector('[data-product-select]');
        forceSubscription(form, variantSelect && variantSelect.value);
      });
    });
  });

  var observer = new MutationObserver(function (mutations) {
    var shouldSync = mutations.some(function (mutation) {
      return Array.prototype.some.call(mutation.addedNodes, function (node) {
        if (node.nodeType !== 1) return false;
        return (
          (node.matches && node.matches(APPSTLE_HIDE_SELECTORS)) ||
          (node.querySelector && node.querySelector(APPSTLE_HIDE_SELECTORS)) ||
          (node.matches && node.matches('.product-single__form--subscription'))
        );
      });
    });

    if (shouldSync) {
      initSubscriptionForms(document);
    }
  });

  if (document.body) {
    observer.observe(document.body, { childList: true, subtree: true });
  }

  initSubscriptionForms(document);
  })();
(function () {
  function giftWrapRoot() {
    return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  }

  function getCart() {
    return fetch(giftWrapRoot() + 'cart.js', {
      headers: {
        'Accept': 'application/json'
      }
    }).then(function (response) {
      if (!response.ok) throw new Error('Cart could not be loaded');
      return response.json();
    });
  }

function syncGiftWrapCheckboxes() {
  getCart()
    .then(function (cart) {
      var wrappedItems = {};

      cart.items.forEach(function (item) {
        if (
          item.properties &&
          item.properties._gift_wrap_for_key
        ) {
          wrappedItems[String(item.properties._gift_wrap_for_key)] = {
            quantity: Number(item.quantity) || 1
          };
        }
      });

      document.querySelectorAll('.gift-wrap-option').forEach(function (option) {
        var checkbox = option.querySelector('.gift-wrap-checkbox');
        if (!checkbox) return;

        var sourceKey = String(option.dataset.sourceKey || '');
        var wrappedItem = wrappedItems[sourceKey];
        var isWrapped = Boolean(wrappedItem);

        checkbox.checked = isWrapped;

        var quantitySelector = option.querySelector('.gift-wrap-multiple');
        var quantityInput = option.querySelector('.gift-wrap-quantity');

        if (quantitySelector) {
          quantitySelector.style.display = isWrapped ? 'block' : 'none';
        }

        if (quantityInput) {
          if (wrappedItem) {
            var maxQuantity = Number(option.dataset.sourceQuantity) || 1;

            quantityInput.value = Math.min(
              wrappedItem.quantity,
              maxQuantity
            );
          } else {
            quantityInput.value = 1;
          }
        }
      });
    })
    .catch(function (error) {
      console.error(error);
    });
}
function removeOrphanGiftWraps() {
  return getCart().then(function (cart) {
    var existingProductKeys = {};
    var updates = {};

    // Répertorie les vrais produits présents dans le panier
    cart.items.forEach(function (item) {
      var isGiftWrap =
        item.properties &&
        item.properties._gift_wrap_for_key;

      if (!isGiftWrap) {
        existingProductKeys[String(item.key)] = true;
      }
    });

    // Trouve les emballages dont le produit associé n'existe plus
    cart.items.forEach(function (item) {
      var wrappedProductKey =
        item.properties &&
        item.properties._gift_wrap_for_key;

      if (
        wrappedProductKey &&
        !existingProductKeys[String(wrappedProductKey)]
      ) {
        updates[item.key] = 0;
      }
    });

    if (Object.keys(updates).length === 0) {
      return false;
    }

    return fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        updates: updates
      })
    })
      .then(function (response) {
        if (!response.ok) {
          throw new Error('Unable to remove orphan gift wrap.');
        }

        return response.json();
      })
      .then(function () {
        return true;
      });
  });
}
function rebuildAndSync() {
  removeOrphanGiftWraps()
    .then(function () {
      document.dispatchEvent(new CustomEvent('cart:build'));

      setTimeout(function () {
        syncGiftWrapCheckboxes();
      }, 500);
    })
    .catch(function (error) {
      console.error('Gift wrap cleanup error:', error);

      document.dispatchEvent(new CustomEvent('cart:build'));

      setTimeout(function () {
        syncGiftWrapCheckboxes();
      }, 500);
    });
}
function cleanupOrphanGiftWrapsOnLoad() {
  removeOrphanGiftWraps()
    .then(function (removed) {
      if (removed) {
        document.dispatchEvent(new CustomEvent('cart:build'));
      }

      setTimeout(function () {
        syncGiftWrapCheckboxes();
      }, 500);
    })
    .catch(function (error) {
      console.error('Gift wrap initial cleanup error:', error);
    });
}

if (document.readyState === 'loading') {
  document.addEventListener(
    'DOMContentLoaded',
    cleanupOrphanGiftWrapsOnLoad
  );
} else {
  cleanupOrphanGiftWrapsOnLoad();
}
  document.addEventListener('change', function (event) {
    var checkbox = event.target.closest('.gift-wrap-checkbox');
    if (!checkbox) return;

    var option = checkbox.closest('.gift-wrap-option');
if (!option) return;

var quantitySelector = option.querySelector('.gift-wrap-multiple');

if (quantitySelector) {
  quantitySelector.style.display = checkbox.checked ? 'block' : 'none';
}

var giftWrapVariantId = Number(option.dataset.giftWrapVariantId);
var giftWrapVariantId = Number(option.dataset.giftWrapVariantId);
var sourceKey = option.dataset.sourceKey;
var sourceVariantId = option.dataset.sourceVariantId;

console.log('GIFT WRAP DEBUG', {
  checked: checkbox.checked,
  giftWrapVariantId: giftWrapVariantId,
  sourceKey: sourceKey,
  sourceVariantId: sourceVariantId
});

if (!giftWrapVariantId || !sourceKey) return;

    checkbox.disabled = true;

    if (checkbox.checked) {

      getCart()
        .then(function (cart) {
          var alreadyExists = cart.items.some(function (item) {
            return (
              Number(item.variant_id) === giftWrapVariantId &&
              item.properties &&
              item.properties._gift_wrap_for_key === sourceKey
            );
          });

          if (alreadyExists) {
            return null;
          }

          return fetch(giftWrapRoot() + 'cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Accept': 'application/json'
            },
            body: JSON.stringify({
              items: [
                {
                  id: giftWrapVariantId,
                  quantity: 1,
                  properties: {
                    '_gift_wrap_for_key': sourceKey,
                    '_gift_wrap_for_variant': sourceVariantId
                  }
                }
              ]
            })
          });
        })
        .then(function (response) {
          if (response && !response.ok) {
            throw new Error('Gift wrap could not be added');
          }

          rebuildAndSync();
        })
        .catch(function (error) {
          console.error(error);
          checkbox.checked = false;
        })
        .finally(function () {
          checkbox.disabled = false;
        });

} else {

  getCart()
    .then(function (cart) {
      var giftWrapLines = cart.items.filter(function (item) {
        return (
          Number(item.variant_id) === giftWrapVariantId &&
          item.properties &&
          (
            item.properties._gift_wrap_for_key === sourceKey ||
            String(item.properties._gift_wrap_for_variant) === String(sourceVariantId)
          )
        );
      });

      if (!giftWrapLines.length) return;

      return Promise.all(
        giftWrapLines.map(function (item) {
          return fetch(giftWrapRoot() + 'cart/change.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Accept': 'application/json'
            },
            body: JSON.stringify({
              id: item.key,
              quantity: 0
            })
          }).then(function (response) {
            if (!response.ok) {
              throw new Error('Gift wrap could not be removed');
            }

            return response.json();
          });
        })
      );
    })
    .then(function () {
      rebuildAndSync();
    })
    .catch(function (error) {
      console.error(error);
      checkbox.checked = true;
    })
    .finally(function () {
      checkbox.disabled = false;
    });
}
  });
document.addEventListener('click', function (event) {
  var minusButton = event.target.closest('.gift-wrap-qty-minus');
  var plusButton = event.target.closest('.gift-wrap-qty-plus');

  if (!minusButton && !plusButton) return;

  event.preventDefault();
  event.stopImmediatePropagation();

  var button = minusButton || plusButton;
  var option = button.closest('.gift-wrap-option');
  if (!option) return;

  var input = option.querySelector('.gift-wrap-quantity');
  var checkbox = option.querySelector('.gift-wrap-checkbox');

  if (!input || !checkbox) return;

  var currentQuantity = Number(input.value) || 1;
  var maxQuantity = Number(option.dataset.sourceQuantity) || 1;

  var newQuantity = currentQuantity;

  if (plusButton) {
    newQuantity = Math.min(currentQuantity + 1, maxQuantity);
  }

  if (minusButton) {
    newQuantity = Math.max(currentQuantity - 1, 1);
  }

  if (newQuantity === currentQuantity) return;

  input.value = newQuantity;

  var giftWrapVariantId = Number(option.dataset.giftWrapVariantId);
  var sourceKey = option.dataset.sourceKey;

  button.disabled = true;

  getCart()
    .then(function (cart) {
      var giftWrapLine = cart.items.find(function (item) {
        return (
          Number(item.variant_id) === giftWrapVariantId &&
          item.properties &&
          item.properties._gift_wrap_for_key === sourceKey
        );
      });

      if (!giftWrapLine) {
        throw new Error('Gift wrap line could not be found');
      }

      return fetch(giftWrapRoot() + 'cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          id: giftWrapLine.key,
          quantity: newQuantity
        })
      });
    })
    .then(function (response) {
      if (!response.ok) {
        throw new Error('Gift wrap quantity could not be updated');
      }

      return response.json();
    })
    .then(function () {
      rebuildAndSync();
    })
    .catch(function (error) {
      console.error(error);
      syncGiftWrapCheckboxes();
    })
    .finally(function () {
      button.disabled = false;
    });

}, true);

  document.addEventListener('cart:updated', function () {
    setTimeout(syncGiftWrapCheckboxes, 300);
  });

  document.addEventListener('page:loaded', function () {
    setTimeout(syncGiftWrapCheckboxes, 300);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      syncGiftWrapCheckboxes();
    });
  } else {
    syncGiftWrapCheckboxes();
  }
  var giftWrapSyncTimer;

var giftWrapObserver = new MutationObserver(function (mutations) {
  var giftWrapWasAdded = mutations.some(function (mutation) {
    return Array.prototype.some.call(mutation.addedNodes, function (node) {
      if (node.nodeType !== 1) return false;

      return (
        (node.matches && node.matches('.gift-wrap-option')) ||
        (node.querySelector && node.querySelector('.gift-wrap-option'))
      );
    });
  });

  if (!giftWrapWasAdded) return;

  clearTimeout(giftWrapSyncTimer);

  giftWrapSyncTimer = setTimeout(function () {
    syncGiftWrapCheckboxes();
  }, 150);
});

if (document.body) {
  giftWrapObserver.observe(document.body, {
    childList: true,
    subtree: true
  });
}
})();